export function transformText(text = '', method = ''){
    let transformedText = '';
    switch(method){
        case 'ucfirst':
            transformedText = ucfirst(text);
        break;
        case 'upper':
            transformedText = toUpperCase(text);
        break;
        case 'lower':
            transformedText = toLowerCase(text);
        break;
        case 'capitalize':
            transformedText = capitalizeWords(text);
        break;
        default:
            transformedText = text;
        break;
    }
    return transformedText;
}

export function ucfirst(str) {
    if (!str || str == '' || typeof str !== 'string') return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function toUpperCase(str) {
    if (!str) return str;
    return str.toUpperCase();
}

export function toLowerCase(str) {
    if (!str) return str;
        return str.toLowerCase();
}

export function capitalizeWords(str) {
    if (!str) return str;
    return str.split(' ').map((word) => {
        return word.length > 2 
            ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            : word.toLowerCase();
    }).join(' ');
}

export function limitText(str = '', length = 50) {
    if(str == '')
        return str;
    let index = 0;
    let limitedText = '';
    for(let char of str){
        if(index >= length){
            limitedText += '...';
            break;
        }
        limitedText += char;
        index++;
    }
    return limitedText;
}

export function makeSlug(val = ''){
    if(val == '')
        return '';
    let arr = val.split(' ');
    return toLowerCase(arr.join('-'));
}

export function isTextValid(str = ''){
    return ['',null,undefined].includes(str) ? false : true;
}

export function getInitials(str = ''){
    if (!str) {
        return str;
    }
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

    let initials = [...str.matchAll(rgx)] || [];

    return (
        (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
    ).toUpperCase();
}